import { httpClient } from '@/shared/services/httpClient';

export const getStaticSource = (url: string): Promise<any> => httpClient.client
  .get(url)
  .then(res => res.data)
  .catch(error => {
    throw error;
  });

// TODO: change this to real number
export const getUserPhone = (): Promise<string> => new Promise(res => {
  setTimeout(() => {
    res('053 7****10');
  }, 1000);
});

export const ResourcesService = {
  getStaticSource,
  getUserPhone,
};
